import { getApiBaseUrl } from '../config/api';

// FEAT-046 — Web client for the per-module acknowledgment gate
// (MVP-18.20). POSTs to /api/training/modules/:moduleId/ack.
// Idempotent: the API replies 200 + alreadyExisted:true on replay.

export type AcknowledgmentMethod = 'CHECKBOX' | 'BUTTON';

export interface ModuleAcknowledgment {
  id: string;
  caregiverId: string;
  moduleId: string;
  contentVersion: number;
  method: AcknowledgmentMethod;
  acknowledgedAt: string;
}

export interface RecordAcknowledgmentResponse {
  acknowledgment: ModuleAcknowledgment;
  alreadyExisted: boolean;
}

export interface RecordAcknowledgmentInput {
  moduleId: string;
  contentVersion?: number;
  method?: AcknowledgmentMethod;
}

class ModuleAcknowledgmentService {
  private async getAuthHeaders(): Promise<HeadersInit> {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async recordAcknowledgment(
    input: RecordAcknowledgmentInput,
  ): Promise<RecordAcknowledgmentResponse> {
    const baseUrl = await getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/training/modules/${encodeURIComponent(input.moduleId)}/ack`,
      {
        method: 'POST',
        headers: await this.getAuthHeaders(),
        body: JSON.stringify({
          contentVersion: input.contentVersion ?? 1,
          method: input.method ?? 'CHECKBOX',
        }),
      },
    );

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(
        body?.error || body?.message || 'Could not record your acknowledgment right now',
      );
    }

    return response.json();
  }
}

export const moduleAcknowledgmentService = new ModuleAcknowledgmentService();
